import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../config/routes';
import { useAuth } from '../../contexts/AuthContext';

interface RegisterForm {
  email: string;
  password: string;
  confirmPassword: string;
  userType: 'Employer' | 'Contractor';
}

const Register: React.FC = () => {
  const navigate = useNavigate();
  const { register: registerUser } = useAuth();
  const { register, handleSubmit, formState: { errors }, watch } = useForm<RegisterForm>();
  const password = watch('password');

  const onSubmit = async (data: RegisterForm) => {
    try {
      await registerUser(data.email, data.password, data.userType);
      // The register function will handle navigation
    } catch (error) {
      console.error('Registration failed:', error);
    }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="mt-8 flex flex-col items-center">
        <h1 className="text-2xl font-bold mb-4">
          Sign up
        </h1>
        <form onSubmit={handleSubmit(onSubmit)} className="w-full mt-4">
          <div className="mb-4">
            <input
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              id="email"
              type="email"
              placeholder="Email Address"
              autoComplete="email"
              autoFocus
              {...register('email', { required: true })}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">Email is required</p>
            )}
          </div>
          <div className="mb-4">
            <input
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              type="password"
              id="password"
              placeholder="Password"
              autoComplete="new-password"
              {...register('password', { required: true })}
            />
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">Password is required</p>
            )}
          </div>
          <div className="mb-4">
            <input
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              type="password"
              id="confirmPassword"
              placeholder="Confirm Password"
              autoComplete="new-password"
              {...register('confirmPassword', {
                required: true,
                validate: value => value === password || 'Passwords do not match'
              })}
            />
            {errors.confirmPassword && (
              <p className="text-red-500 text-sm mt-1">{errors.confirmPassword.message}</p>
            )}
          </div>
          <div className="mb-4">
            <select
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              id="userType"
              {...register('userType', { required: true })}
            >
              <option value="">Select User Type</option>
              <option value="Employer">Employer</option>
              <option value="Contractor">Contractor</option>
            </select>
            {errors.userType && (
              <p className="text-red-500 text-sm mt-1">User type is required</p>
            )}
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Sign Up
          </button>
          <button
            type="button"
            className="w-full mt-2 text-blue-600 hover:text-blue-700 focus:outline-none"
            onClick={() => navigate(ROUTES.LOGIN)}
          >
            Already have an account? Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register; 